import { render, staticRenderFns } from "./customMenu.vue?vue&type=template&id=210ea3b6&scoped=true"
import script from "./customMenu.vue?vue&type=script&lang=js"
export * from "./customMenu.vue?vue&type=script&lang=js"
import style0 from "./customMenu.vue?vue&type=style&index=0&id=210ea3b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ea3b6",
  null
  
)

export default component.exports